import React from 'react'
import { useLocation } from 'react-router-dom'
import History from './History';
import BottomMenu from './components/BottomMenu';

const HistoryPage = ({userData}) => {
    const location = useLocation();
    const { gameId } = location.state;
    const { teamId } = location.state;

    return (
        <div className='max-w-5xl mx-auto my-6'>
            <History gameId={gameId} teamId={teamId} likes={userData.likes} uid={userData.uid} />

            {/* 下部固定メニュー */}
            <BottomMenu gameId={gameId} teamId={teamId} />
        </div>
    )
}

export default HistoryPage